import Loadable from "layouts/full/shared/loadable/Loadable";
import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

/* ****Pages***** */
// Private pages
const Dashboard = Loadable(lazy(() => import("pages/dashboard")));
const Schedule = Loadable(lazy(() => import("pages/schedule")));
const CreateClassSchedule = Loadable(
  lazy(() => import("pages/schedule/createclass"))
);
const CreateEventSchedule = Loadable(
  lazy(() => import("pages/schedule/createevent"))
);
const Classess = Loadable(lazy(() => import("pages/classes")));
const CreateClass = Loadable(lazy(() => import("pages/classes/createclass")));
const DetailClasses = Loadable(lazy(() => import("pages/classes/detail")));
const Play = Loadable(lazy(() => import("pages/play")));
const Classroom = Loadable(lazy(() => import("pages/classroom")));
const Ticket = Loadable(lazy(() => import("pages/ticket")));
const CreateTicket = Loadable(lazy(() => import("pages/ticket/createticket")));
const Invoice = Loadable(lazy(() => import("pages/invoice")));
const Analytics = Loadable(lazy(() => import("pages/analytics")));
const Settings = Loadable(lazy(() => import("pages/settings")));
const Booking = Loadable(lazy(() => import("pages/booking")));
const Customer = Loadable(lazy(() => import("pages/customer")));
const CustomerDetail = Loadable(lazy(() => import("pages/customer/detail")));
const CustomerAdd = Loadable(lazy(() => import("pages/customer/add")));

// Public pages
const Register = Loadable(lazy(() => import("pages/Authentication/register")));
const Login = Loadable(lazy(() => import("pages/Authentication/login")));
const FourZeroFour = Loadable(lazy(() => import("pages/z-error/404")));

const authProtectedRoutes = [
  { path: "/", element: <Navigate to="/home" /> },
  { path: "/home", exact: true, element: <Dashboard /> },
  { path: "/schedule", element: <Schedule /> },
  { path: "/schedule/class/create", element: <CreateClassSchedule /> },
  { path: "/schedule/event/create", element: <CreateEventSchedule /> },
  { path: "/classes", element: <Classess /> },
  { path: "/classes/create", element: <CreateClass /> },
  { path: "/classes/edit/:id", element: <CreateClass /> },
  { path: "/classes/:id", element: <DetailClasses /> },
  { path: "/classroom", element: <Classroom /> },
  { path: "/play", element: <Play /> },
  { path: "/ticket", element: <Ticket /> },
  { path: "/ticket/create", element: <CreateTicket /> },
  { path: "/ticket/edit/:id", element: <CreateTicket /> },
  { path: "/analytics", element: <Analytics /> },
  { path: "/invoice", element: <Invoice /> },
  { path: "/settings", element: <Settings /> },
  { path: "/booking", element: <Booking /> },
  { path: "/customer", element: <Customer /> },
  { path: "/customer/:id", element: <CustomerDetail /> },
  { path: "/customer/add", element: <CustomerAdd /> },
  { path: "*", element: <FourZeroFour /> },
];

const publicRoutes = [
  { path: "/register", element: <Register /> },
  { path: "/login", element: <Login /> },
  { path: "*", element: <FourZeroFour /> },
];

export { authProtectedRoutes, publicRoutes };
